<template>
  <div class="bg-white border border-section_border border-b-0 rounded">
    <ul class="genre-place-list">
      <li v-for="place in places" v-bind:key="place.id" class="border-b">
        <genre-place @openPlace="$emit('openPlace', place)" :place="place" />
      </li>
    </ul>
  </div>
</template>

<script>
import GenrePlace from './GenrePlace'

export default {
  components: {
    GenrePlace
  },
  props: {
    genre: {
      type: Object,
      required: true
    }
  },
  computed: {
    places: function () {
      return this.$store.getters['places/getPlacesByGenre'](this.genre)
    }
  }
}
</script>
